import React from "react"
import i18n from "i18next"

export default function PrivacyNotice() {
  const notice = i18n.t("newsletters.privacy_notice", "", { returnObjects: true })
  if (!notice) return null

  return <div className="text-[10px] mt-4 whitespace-pre-line">{notice}</div>
}
